export function LogModel({
    logId,
    deviceUid,

    userName,
    userEmail,
    
    logType,
    logTypeName,

    actionType,

    status,
    statusLabel,

    datetime,
} = {}) {
    return {
        logId,
        deviceUid,

        userName,
        userEmail,

        logType,
        logTypeName,

        actionType,

        status,
        statusLabel,

        datetime,
    };
}